module.exports = __webpack_public_path__ + "c8610563455f1c052e93b5f296ebaebc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/multitenant.png
// module id = 260
// module chunks = 1